<template>
  <div class="blog-detail">
    <vue-element-loading :active="appLoading" spinner="bar-fade-scale" color="#005f32" size="60" is-full-screen />
    <!-- Hero Banner Section -->
    <v-layout column>
      <v-flex xs12>
        <div class="hero-banner1 hidden-sm-and-up" style="background-color: #005f32">
          <v-layout align-center justify-center fill-height class="text-center pa-4 overlay-content">
            <v-flex xs12>
              <h1 class="white--text font-weight-bold text-shadow">
                WILD BYTES
              </h1>
            </v-flex>
          </v-layout>
        </div>
        <div class="hero-banner hidden-xs-only" style="background-color: #005f32">
          <v-layout column align-center justify-center fill-height class="text-center pa-4">
            <v-flex xs12 sm8 md6 pt-16 mt-16>
              <h1 class="white--text font-weight-bold">WILD BYTES</h1>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
    </v-layout>

    <!-- Content Section -->
    <v-layout justify-center>
      <v-flex xs11 sm9 class="pa-2">
        <v-layout wrap justify-center>
          <v-flex xs12 md9>
            <!-- Original Image and Title Section moved here -->
            <v-layout column v-if="blogview.images" class="mt-4" pt-16 pt-sm-0>
              <v-flex xs12 pt-16 pt-sm-0>
                <v-img :src="mediaURL + blogview.images[0]" class="hidden-sm-and-up" style="cursor: pointer" contain :alt="blogview.title">
                </v-img>
                <div class="hidden-xs-only" :style="`background-image: url('${mediaURL + blogview.images[0]
                  }'); height: 250px; background-size: cover; background-position: center;cursor: pointer;`"
                  @click="openImageDialog">
                  <!-- <v-layout
                    column
                    align-center
                    justify-center
                    fill-height
                    class="text-center pa-4"
                  >
                    <v-flex xs12 sm8 md6>
                      <h1 class="white--text font-weight-bold">
                        {{ blogview.title }}
                      </h1>
                    </v-flex>
                  </v-layout> -->
                </div>
              </v-flex>
            </v-layout>
            <!-- About Section -->
            <!-- <div class="about-section mt-8"> -->
            <v-layout wrap align-center class="my-3">
              <!-- Date section on the left -->
              <v-flex xs2 sm1 class="text-start">
                <div class="date-block">
                  <div style="font-size: 41px; font-weight: bold; line-height: 1">
                    {{ new Date(blogview.uploadedDate || blogview.createdAt).getDate() }}
                  </div>
                  <div style="
                      color: #666;
                      font-family: poppinsregular;
                      font-size: 15px;
                    ">
                    {{
                      new Date(blogview.uploadedDate || blogview.createdAt)
                        .toLocaleString("default", { month: "short" })
                    .toUpperCase()
                    }}
                  </div>
                </div>
              </v-flex>

              <!-- Title/description on the right -->
              <v-flex xs10 sm11 py-4 text-start>
                <span style="
                    color: #005f32;
                    font-family: oswaldbold;
                    font-size: 26px;
                    text-align: left;
                    line-height: normal;
                  ">
                  {{ blogview.shortDiscription }}
                </span>
              </v-flex>
            </v-layout>
            <!-- <v-layout wrap justify-center class="my-3">
              <v-flex xs10>
                <span
                  style="font-family: poppinslight; color: black"
                  class="pageSize"
                  v-html="blogview.content"
                ></span>
              </v-flex>
            </v-layout> -->
            <v-layout wrap justify-center class="my-3">
              <v-flex xs12>
                <v-layout wrap justify-center>
                  <v-flex xs2 sm1> </v-flex>
                  <v-flex xs10 sm11>
                    <div v-if="processedSubcontents && processedSubcontents.length">
                      <div v-for="(sub, idx) in processedSubcontents" :key="sub._id || idx" class="mb-6">
                        <div class="pageSize text-left" style="font-family: poppinslight; color: black"
                          v-html="sub.content"></div>
                        <div v-if="sub.image && sub.image.length && sub.image[0]" class="my-3 px-sm-3">
                          <div style="
                              border: 1px solid #000;
                              padding: 10px;
                              display: inline-block;
                              width: 100%;
                              background: #fafafa;
                              text-align: center;
                            ">
                            <v-img :src="mediaURL + sub.image[0]" max-width="100%" max-height="500" class="mb-2"
                              contain :alt="sub.imagecaption || blogview.title"></v-img>
                            <div v-if="sub.imagecaption" style="
                                font-size: 12px;
                                color: black;
                                font-family: poppinsregular;
                                margin-top: 8px;
                                text-align: center;
                              ">
                              {{ sub.imagecaption }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <span style="font-family: poppinslight; color: black" class="pageSize"
                        v-html="blogview.content"></span>
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout wrap class="mb-3">
              <v-flex xs10 offset-xs1>
                <hr style="
                    border: none;
                    border-top: 1.5px solid #ccc;
                    width: 40%;
                    margin: 32px auto 16px auto;
                  " />
              </v-flex>
            </v-layout>
            <v-layout wrap v-if="blogview.author" class="mb-3">
              <v-flex xs12>
                <v-layout wrap justify-center>
                  <v-flex xs2 sm1></v-flex>
                  <v-flex xs10 sm11 offset-xs1 text-start>
                    <span style="
                        font-family: poppinsregular;
                        color: black;
                        font-size: 16px;
                      ">
                      by {{ blogview.author }}
                    </span>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <!-- </div> -->
          </v-flex>
          <v-flex xs12 md3>
            <!-- Right sidebar -->
            <div class="recent-articles-sidebar pa-4">
              <h3 class="mb-4" style="
                  color: black;
                  font-weight: 10;
                  font-family: poppinsmedium;
                  text-align: left;
                  text-transform: uppercase;
                ">
                Recent Blogs
              </h3>
              <v-list dense v-if="recentBlogs && recentBlogs.length > 1">
                <v-list-item v-for="(article, index) in recentBlogs" :key="index" @click="navigateToBlog(article)"
                  class="px-0 py-2" :ripple="false">
                  <v-list-item-content>
                    <v-list-item-title class="recent-article-title pl-6" style="
                        font-family: poppinsregular;
                        font-size: 14px;
                        line-height: 1.4;
                        white-space: normal;
                        text-align: left;
                      ">
                      <span>></span>&nbsp;&nbsp;{{ article.title }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <v-list dense v-else>
                <v-list-item class="px-0 py-2">
                  <v-list-item-content>
                    <v-list-item-title class="recent-article-title pl-6" style="
                        font-family: poppinsregular;
                        font-size: 14px;
                        line-height: 1.4;
                        white-space: normal;
                        text-align: left;
                      ">
                      No recent blogs !
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-dialog v-model="imageDialog" max-width="90%">
      <v-card>
        <v-card-title class="headline">
          <!-- <span>{{ blogview.title }}</span> -->
          <v-spacer></v-spacer>
          <v-btn icon @click="imageDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-img :src="mediaURL + blogview.images[0]" max-height="80vh" contain></v-img>
        <v-card-title></v-card-title>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
export default {
  metaInfo() {
    return {
      title: this.blogview
        ? `${this.blogview.title} | WTI-WILD BYTES`
        : "Wild Bytes | Wildlife Trust of India",
      meta: [
        {
          name: "description",
          content: this.blogview
            ? this.blogview.shortDiscription
            : "Explore the blog from the Wildlife Trust of India, featuring news, updates, and in-depth articles on wildlife conservation across India.",
        },
        {
          name: "keywords",
          content: this.blogview
            ? `${this.blogview.title}, WTI, Wildlife Trust of India, conservation`
            : "blog, wildlife, conservation, India, Wild Bytes",
        },
        { name: "author", content: "Wildlife Trust of India" },
        // Open Graph tags
        {
          property: "og:title",
          content: this.blogview
            ? `${this.blogview.title} | WTI-WILD BYTES`
            : "Wild Bytes | Wildlife Trust of India",
        },
        {
          property: "og:description",
          content: this.blogview
            ? this.blogview.shortDiscription
            : "Explore the blog from the Wildlife Trust of India, featuring news, updates, and in-depth articles on wildlife conservation across India.",
        },
        { property: "og:type", content: "article" },
        { property: "og:url", content: window.location.href },
        {
          property: "og:image",
          content:
            this.blogview &&
            this.blogview.images &&
            this.blogview.images.length > 0
              ? this.mediaURL + this.blogview.images[0]
              : "https://www.wti.org.in/wp-content/uploads/2021/10/WTI-featured-image_3.jpg",
        },
        // Twitter Card tags
        { name: "twitter:card", content: "summary_large_image" },
        {
          name: "twitter:title",
          content: this.blogview
            ? `${this.blogview.title} | WTI-WILD BYTES`
            : "Wild Bytes | Wildlife Trust of India",
        },
        {
          name: "twitter:description",
          content: this.blogview
            ? this.blogview.shortDiscription
            : "Explore the blog from the Wildlife Trust of India, featuring news, updates, and in-depth articles on wildlife conservation across India.",
        },
        {
          name: "twitter:image",
          content:
            this.blogview &&
            this.blogview.images &&
            this.blogview.images.length > 0
              ? this.mediaURL + this.blogview.images[0]
              : "https://www.wti.org.in/wp-content/uploads/2021/10/WTI-featured-image_3.jpg",
        },
      ],
      link: [
        { rel: "canonical", href: window.location.href }
      ],
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            "headline": this.blogview ? this.blogview.title : "Wild Bytes",
            "description": this.blogview ? this.blogview.shortDiscription : "",
            "image": this.blogview && this.blogview.images ? this.mediaURL + this.blogview.images[0] : "",
            "author": {
              "@type": "Organization",
              "name": "Wildlife Trust of India"
            },
            "publisher": {
              "@type": "Organization",
              "name": "Wildlife Trust of India",
              "logo": {
                "@type": "ImageObject",
                "url": "https://www.wti.org.in/wp-content/uploads/2017/04/wti-logo.png"
              }
            },
            "datePublished": this.blogview ? (this.blogview.uploadedDate || this.blogview.createdAt) : ""
          }
        }
      ]
    };
  },
  data() {
    return {
      blogview: {},
      recentBlogs: [],
      appLoading: true,
      imageDialog: false,
    };
  },
  mounted() {
    if (this.blogview && this.blogview.content) {
      this.blogview.content = this.cleanHTML(this.blogview.content);
    }
    this.viewBlog();
    this.getRecentBlogs();
  },
  computed: {
    // processedSubcontents() {
    //   // Replace YouTube links with iframe embeds in each subcontent
    //   return (this.blogview.subcontents || []).map((sub) => {
    //     let content = sub.content || "";
    //     // Regex for YouTube links
    //     const ytRegex = /https?:\/\/(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([A-Za-z0-9_-]+)/g;
    //     content = content.replace(ytRegex, (match, videoId) => {
    //       return `<div style="text-align:center;">
    //       <iframe width="650px" height="450px" src="https://www.youtube.com/embed/${videoId}" frameborder="0" allowfullscreen></iframe>
    //     </div>`;
    //     });
    //     return { ...sub, content };
    //   });
    // },
    processedSubcontents() {
  if (!this.blogview.subcontents || !this.blogview.subcontents.length) {
    return null;
  }

  const displayedVideos = new Set(); // Track displayed video IDs
  
  return this.blogview.subcontents.map((sub) => {
    let content = sub.content || "";
    
    // Regex for YouTube links
    const ytRegex = /https?:\/\/(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([A-Za-z0-9_-]+)/g;
    
    content = content.replace(ytRegex, (match, videoId) => {
      // Check if this video has already been displayed
      if (displayedVideos.has(videoId)) {
        return ''; // Return empty string if already displayed
      }
      
      // Add to displayed videos set
      displayedVideos.add(videoId);
      
      return `<div style="text-align:center;">
        <iframe width="650px" height="450px" src="https://www.youtube.com/embed/${videoId}" frameborder="0" allowfullscreen></iframe>
      </div>`;
    });
    
    return { ...sub, content };
  });
},
  },
  methods: {
    cleanHTML(rawHtml) {
      return rawHtml
        .replace(/<p>(&nbsp;|\s|<br>)<\/p>/g, "") // Remove empty <p> tags
        .replace(/<br\s*\/?>\s*<br\s*\/?>/g, "<br>") // Replace multiple <br> with one
        .replace(/\s+/g, " ") // Remove excessive whitespace
        .trim();
    },
    openImageDialog() {
      this.imageDialog = true;
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = String(dt.getDate()).padStart(2, "0"); // Add leading zero if needed
      var month = String(dt.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so add 1
      var year = dt.getFullYear();
      return `${day}-${month}-${year}`;
    },
    viewBlog() {
      this.appLoading = true;
      axios({
        url: "/employee/blog/view/" + this.$route.params.slug,
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        //   params: {
        //     limit: this.limit,
        //     page: this.currentPage,
        //     username: this.search,
        //   },
      })
        .then((response) => {
          this.appLoading = false;
          this.blogview = response.data.data;
          this.getRecentBlogs();
          //this.pages = Math.ceil(response.data.totalLength / this.limit);
        })
        .catch((err) => {
          this.appLoading = false;
          (this.ServerError = true), console.log(err);
        });
    },
    getRecentBlogs() {
      axios({
        url: "/employee/blog/list",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          limit: 6, // Get only 6 recent blogs
        },
      })
        .then((response) => {
          // Filter out the current blog if it exists in the list
          this.recentBlogs = response.data.data
            .filter(
              (blog) => !this.blogview._id || blog._id !== this.blogview._id
            )
            .slice(0, 5); // Limit to 5 items
        })
        .catch((err) => {
          console.log(err);
        });
    },
    navigateToBlog(blog) {
      if (blog.slug === this.$route.params.slug) return;
      this.$router.push(`/wildBytes/${blog.slug}`);
    },
  },
};
</script>

<style scoped>
.hero-banner {
  height: 60vh;
  background-size: cover;
  background-position: center;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hero-banner::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

@media (max-width: 600px) {
  .hero-banner {
    height: 40vh;
  }
}

.hero-banner1 h1,
.hero-banner h1 {
  font-size: 3rem;
  /* Increase the font size */
}

@media (max-width: 600px) {

  .hero-banner1 h1,
  .hero-banner h1 {
    font-size: 2.5rem;
    /* Adjust font size for smaller screens */
  }
}
</style>
<style>
.pageSize p {
  margin: 0 0 10px 0;
  padding: 0;
  text-align: justify;
}

.pageSize br {
  display: none;
}

.pageSize p img {
  width: 100%;
  max-height: auto;
  display: block;
  border: 1px solid #000;
  border-radius: 8px;
  padding: 10px;
}

.hero-banner1 {
  position: relative;
}

.overlay-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
}

.date-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.text-shadow {
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.6);
}

.recent-articles-sidebar {
  margin-top: 20px;
}

.recent-article-title {
  color: #0b4e1e;
  transition: color 0.2s;
}

.v-list-item:hover .recent-article-title {
  color: #eaa00c;
}

.v-list-item {
  border-bottom: 1px solid #eee;
}

/* Remove background color from all Vuetify list item elements on hover */
.v-list-item:hover,
.v-list-item--link:hover,
.v-list-item:focus,
.v-list-item--active,
.v-list-item--highlighted {
  background-color: transparent !important;
}

/* Target the title element specifically */
.v-list-item-title:hover,
.v-list-item__title:hover {
  background-color: transparent !important;
}

.v-list-item:last-child {
  border-bottom: none;
}

/* Override Vuetify's hover background styles */
.v-list-item.v-list-item--link:before,
.v-list-item.v-list-item--link:hover:before,
.v-list-item.v-list-item--link:focus:before,
.v-list-item.v-list-item--link:active:before {
  opacity: 0 !important;
  background-color: transparent !important;
}

/* Ensure the ripple effect is disabled */
.v-ripple__container {
  display: none !important;
}

/* Target Vuetify's internal hover classes */
.v-list-item__content:hover,
.v-list-item__title:hover {
  background-color: transparent !important;
}

/* Make sure the hover state only affects text color */
.theme--light.v-list-item:hover::before,
.theme--dark.v-list-item:hover::before {
  opacity: 0 !important;
}

.pageSize iframe {
  width: 650px;
  height: 450px;
  max-width: 100%;
}

@media (max-width: 600px) {
  .pageSize iframe {
    width: 300px !important;
    height: 250px !important;
  }
}
</style>
